// frontend/book-app-frontend/src/components/ReaderDashboard.js
import React, {useContext} from 'react';
import { Outlet } from 'react-router-dom';
import { LanguageContext } from '../contexts/LanguageProvider';


function ReaderDashboard() {
  const {language} = useContext(LanguageContext);
  const translates = {
    pt:{reader:'Leitor Dashboard',},
    en:{reader:'Reader Dashboard' }
  }

  const t = translates[language] || language.pt;
  return (
    <div >
      <h1>{t.reader}</h1>
      <Outlet />
    </div>
  );
}

export default ReaderDashboard;